<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 xl12 md12 sm12 lg12>
        <div class="title text-xs-center form-divider margin-top-40px mb-2">
          <h2 large outline flat>آرشیو نماینده های فروش</h2>
        </div>
      </v-flex>
    </v-layout>
    <v-layout row class="margin-top-40px">
      <v-flex xs12 lg12 sm12 xl12 md12 >
        <v-tabs dark color="indigo" show-arrows>
          <v-tabs-slider color="yellow"></v-tabs-slider>
          <v-tab v-for="i in TabItems" :href="'#' + i.path" :key="i.path">
            <v-icon>{{i.icon}}</v-icon>
            {{i.title}}
          </v-tab>
          <v-tabs-items>
            <v-tab-item id="Users">
              <v-card class="full-width">
                <v-data-table
                  :loading="datatableBool"
                  no-data-text="داده ای یافت نشد"
                  next-icon="$vuetify.icons.prev"
                  prev-icon="$vuetify.icons.next"
                  rows-per-page-text="تعداد سطر در هر صفحه :"
                  :headers="adminTableHeader"
                  :items="UserTableItems"
                >
                  <template slot="items" slot-scope="props">
                    <td>{{props.item.counter}}</td>
                    <td class="text-xs-right">{{props.item.name}}</td>
                    <td class="text-xs-right">{{props.item.username}}</td>
                    <td class="text-xs-right ltr">{{props.item.no}}</td>
                    <td class="text-xs-right ltr">{{props.item.email}}</td>
                    <td class="text-xs-right">{{props.item.codeMelli}}</td>
                    <td class="text-xs-right">{{props.item.phone}}</td>
                    <td class="text-xs-right">{{props.item.email}}</td>
                    <td class="text-xs-right">
                      <v-icon small color="primary" @click="editUser(props.item.id)">create</v-icon>
                      <v-icon small color="error" @click="deleteUser(props.item.id)">delete</v-icon>
                    </td>
                  </template>
                </v-data-table>
              </v-card>
            </v-tab-item>
            <v-tab-item id="BlockedUsers">
              <v-card class="full-width">
                <v-data-table
                  :loading="userDeletedDataTableLoading"
                  no-data-text="داده ای یافت نشد"
                  next-icon="$vuetify.icons.prev"
                  prev-icon="$vuetify.icons.next"
                  rows-per-page-text="تعداد سطر در هر صفحه :"
                  :headers="adminTableHeader"
                  :items="disabledUserTableItems"
                >
                  <template slot="items" slot-scope="props">
                    <td>{{props.item.counter}}</td>
                    <td class="text-xs-right">{{props.item.name}}</td>
                    <td class="text-xs-right">{{props.item.username}}</td>
                    <td class="text-xs-right ltr">{{props.item.no}}</td>
                    <td class="text-xs-right ltr">{{props.item.email}}</td>
                    <td class="text-xs-right">{{props.item.codeMelli}}</td>
                    <td class="text-xs-right">
                      <v-btn
                        icon
                        color="primary"
                        small
                        @click.stop="$set(dialogNote, props.item.id, true)"
                      >
                        <v-icon small>open_in_new</v-icon>
                      </v-btn>
                      <v-dialog
                        v-model="dialogNote[props.item.id]"
                        scrollable
                        lazy
                        max-width="500"
                        :key="props.item.id"
                      >
                        <v-card>
                          <v-card-title>
                            <span>پیام</span>
                          </v-card-title>
                          <v-card-text>{{props.item.phone}}</v-card-text>
                          <v-card-actions>
                            <v-btn
                              color="primary"
                              flat
                              @click.stop="$set(dialogNote, props.item.id, false)"
                            >بستن</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </td>
                    <td class="text-xs-right">{{props.item.email}}</td>
                    <td class="text-xs-right">
                      <v-btn color="orange" small dark @click="RecoverUser(props.item)">
                        <v-icon small color="white">redo</v-icon>بازگرداندن
                      </v-btn>
                    </td>
                  </template>
                </v-data-table>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-flex>
    </v-layout>
    <template>
      <v-layout row justify-center>
        <v-dialog v-model="confirmRecovery" width="500px">
          <v-card>
            <v-card-title>
              <v-icon color="info">redo</v-icon>بازگردانی کاربر
            </v-card-title>
            <v-card-text>کاربر مورد نظر مجددا فعال خواهد شد.ادامه میدهید؟</v-card-text>
            <v-card-action>
              <v-btn flat color="success" @click="RecoverUserDo" :loading="false">بله</v-btn>
              <v-btn flat color="error" @click="confirmRecovery = false">خیر</v-btn>
            </v-card-action>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>
    <template>
      <v-layout row justify-center>
        <v-dialog v-model="ConfirmUser" width="500px">
          <v-card>
            <v-card-title>
              <v-icon color="error">delete</v-icon>حذف کاربر
            </v-card-title>
            <v-card-text>کاربر مورد نظر حذف خواهد شد.ادامه میدهید؟</v-card-text>
            <v-card-action>
              <v-btn flat color="error" @click="DeleteUser" :loading="ConfirmTrueButtonLoading">بله</v-btn>
              <v-btn flat color="info" @click="ConfirmUser = !ConfirmUser">خیر</v-btn>
            </v-card-action>
          </v-card>
        </v-dialog>
      </v-layout>
    </template>
    <template>
      <v-layout row justify-center>
        <v-dialog v-model="editUserDialog" max-width="600px" persistent>
          <v-form ref="UpdateUserForm">
            <v-card>
              <v-card-title>
                <span class="title">ویرایش کاربر سیستم</span>
              </v-card-title>
              <v-card-text>
                <v-container fluid grid-list-xl>
                  <v-layout row>
                    <v-flex xs12>
                      <v-text-field
                        hint="فقط حروف فارسی پشتیبانی میشود"
                        :rules="nameRules"
                        append-icon="account_circle"
                        clearable
                        required
                        solo
                        placeholder="نام و نام خانوادگی کاربر"
                        v-model="USEREDITIONusername"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs12>
                      <v-text-field
                        class="ltr"
                        mask="###-###-####"
                        prefix="+98"
                        hint="لطفا شماره تلفن همراه را بدون صفر وارد نمایید"
                        append-icon="call"
                        clearable
                        required
                        solo
                        placeholder="تلفن همراه"
                        :rules="userTelRules"
                        v-model="USEREDITIONutel"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs12>
                      <v-text-field
                        solo
                        placeholder="پست الکترونیکی"
                        class="ltr"
                        mask
                        hint="yourname@example.com"
                        prepend-inner-icon="email"
                        clearable
                        :rules="userEmailRules"
                        required
                        v-model="USEREDITIONumail"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs12>
                      <v-select
                        solo
                        v-model="USEREDITIONuper"
                        placeholder="دسترسی ها"
                        :rules="userPermissionRules"
                        clearable
                        :items="UserPermissionItems"
                        chips
                        multiple
                        open-on-clear
                        single-line
                        append-icon="perm_data_setting"
                        required
                      ></v-select>
                    </v-flex>
                  </v-layout>
                  <v-layout row>
                    <v-flex xs6>
                      <v-btn block color="primary" :loading="userUpdateLoading" @click="UpdateUser">
                        <v-icon>update</v-icon>بروزرسانی
                      </v-btn>
                    </v-flex>
                    <v-flex xs6>
                      <v-btn block color="error" @click.stop="editUserDialog = !editUserDialog">
                        <v-icon>close</v-icon>بستن
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-form>
        </v-dialog>
      </v-layout>
    </template>
  </div>
</template>

<script>
// eslint-disable-next-line
/* eslint-disable */
import AgentService from "@/services/AgentServices";
export default {
  data() {
    return {
      dialogNote: {},
      TabItems: [
        { title: "کاربران فعال", path: "Users", icon: "account_circle" },
        {
          title: "کاربران حذف شده",
          path: "BlockedUsers",
          icon: "delete"
        }
      ],
      adminTableHeader: [
        { text: "#", sortable: false, value: "counter", align: "right" },
        { text: "نام کاربری", sortable: false, value: "User", align: "right" },
        {
          text: "نام و نام خانوادگی",
          sortable: true,
          value: "Uname",
          align: "right"
        },
        {
          text: "شماره شناسنامه",
          sortable: false,
          value: "1234566",
          align: "right"
        },
        { text: "ایمیل", sortable: false, value: "ureff", align: "right" },
        { text: "کد ملی", sortable: false, value: "melicode", align: "right" },
        { text: "نلفن همراه", sortable: false, value: "utell", align: "right" },
        {
          text: "تعداد کارت NFC",
          sortable: false,
          value: "umail",
          align: "right"
        },
        { text: "  عملیات", sortable: false, value: "none", align: "right" }
      ],
      items: [
        { title: "داشبورد", icon: "dashboard" },
        { title: "مدیریت نمایندگان فروش", icon: "question_answer" },
        { title: "ایجاد اخبار", icon: "question_answer" },
        { title: "مدیریت داوران", icon: "question_answer" },
        { title: "مدیریت کلاس دهی ", icon: "question_answer" },
        { title: "مدیریت مسیرها ", icon: "question_answer" },
        { title: "مدیریت نقطه ها", icon: "question_answer" }
      ],
      UserTableItems: [],
      disabledUserTableItems: [],
      userDeletedDataTableLoading: true,
      datatableBool: true
    };
  },
  async mounted() {
    setTimeout(() => {
      this.userDeletedDataTableLoading = false;
      this.datatableBool = false;
    }, 8000);
    try {
      this.UserTableItems = (await AgentService.index()).data;
      this.disabledUserTableItems = (await AgentService.disIndex()).data;
      this.userDeletedDataTableLoading = false;
      this.datatableBool = false;
    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    async deleteUser(id) {
      try {
        let res = await AgentService.delete(id);
        console.log(res);
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style scoped>
.margin-top-40px {
  margin-top: 40px;
}
.margin-top-20px {
  margin-top: 20px;
}
</style>
